import { render } from "./offersDetails.vue?vue&type=template&id=77d2a096&scoped=true"
import script from "./offersDetails.vue?vue&type=script&lang=js"
export * from "./offersDetails.vue?vue&type=script&lang=js"

import "./offersDetails.vue?vue&type=style&index=0&id=77d2a096&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d2a096"]])

export default __exports__